// A PARTNER-SHELL adatai (`GET /portal/me`) — EGY lekérdezés, amit a shell ÉS a lapok is fogyasztanak.
//
// MIÉRT HOOK: a keret (fiók-váltó, felhasználó-kártya, nav-jelvények) és a kezdőlap ugyanezt az adatot kéri.
// Egy hookkal EGY cache-bejegyzés van rá (`portalKeys.me`), tehát a lap-váltás nem indít új kérést.
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { portalKeys } from '@/features/portal/api';
import { api } from '@/lib/api';

type MeResult = Awaited<ReturnType<typeof api.portal.me.query>>;

/**
 * A shell-adat lekérdezése. A 403 (nincs portál-hozzáférés) SAJÁT állapot, nem hiba — a hívó kezeli.
 *
 * @param accountId a sidebar FIÓK-SCOPE-ja (`null` = „Minden fiók"). A fiók-LISTA ettől függetlenül teljes
 *   marad (abból épül a váltó); a scope a NAV-JELVÉNYEKET szűkíti, hogy ne mondjanak mást, mint a listák.
 */
export function usePortalMe(accountId: string | null): UseQueryResult<MeResult> {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'hu';
  return useQuery({
    queryKey: portalKeys.me(lang, accountId),
    // NYERS ts-rest hívás: így a válasz TELJES status-uniója látszik (403/502 saját állapotként kezelhető).
    queryFn: () =>
      api.portal.me.query({ query: { lang, ...(accountId !== null ? { accountId } : {}) } }),
    // A keret adata lapváltásonként nem változik; a jelvény-számokat a mutációk invalidálják.
    staleTime: 30_000,
  });
}
